var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.55 19.61"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.38 9.55a1 1 0 0 0-1 1v5.37a1.69 1.69 0 0 1-1.68 1.69H5.86a1.69 1.69 0 0 1-1.69-1.69v-2.56a1 1 0 0 0-2 0v2.56a3.69 3.69 0 0 0 3.69 3.69H16.7a3.69 3.69 0 0 0 3.68-3.69v-5.37a1 1 0 0 0-1-1ZM22.11 7 11.83.17a1 1 0 0 0-1.11 0L.45 7A1 1 0 0 0 1 8.86h12.73a1 1 0 0 0 0-2H4.3l7-4.65L21 8.69A1 1 0 1 0 22.11 7Z"
  })));
};
export default SvgHome;